import { Route } from "react-router-dom";
import Flex from "app/components/UI/Flex";
import Link from "app/components/UI/Link";
import MiniCart from "app/components/MiniCart";
import PropTypes from "prop-types";
import React from "react";
import Title from "app/components/UI/Title";
import classes from "./Header.module.css";
import logo from "./logo.png";

export const Header = ({ translate, clubId, navigationEnabled }) => (
  <div className={classes.brandNavbar}>
    <Flex direction="row" middle className={classes.pageContainer}>
      <Flex size={1}>
        <Title component="h2" className={classes.brandName}>
          {navigationEnabled ? (
            <Link to="/" className={classes.brandLogo}>
              <img src={logo} alt="Bluegreen Logo" />
            </Link>
          ) : (
            <a className={classes.brandLogo}>
              <img src={logo} alt="Bluegreen Logo" />
            </a>
          )}
          <span>{translate("Recharges practice en ligne")}</span>
        </Title>
      </Flex>

      <Route path="/:clubId/" component={MiniCart} />
    </Flex>
  </div>
);

Header.propTypes = {
  translate: PropTypes.func.isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./src/app/components/Header/Header.js